import client from './client';

/**
 * Customer Service Warranty lookups (payroll editor M2-B — the CswTaskModal's
 * warranty picker). Mirrors API `GET /admin/customerServiceWarranty`
 * (CustomerServiceWarrantyUtil.mapDBToModel).
 */

export interface CustomerServiceWarrantyOption {
  customerServiceWarrantyID: number;
  accountCodeID: number;
  name: string;
  accountingYear: string | null;
  /** When true the claim must carry a real projectID (the modal enforces it). */
  projectRequired: boolean;
  job: string | null;
}

export const getCustomerServiceWarranties = async (): Promise<CustomerServiceWarrantyOption[]> => {
  try {
    const response = await client.get('/admin/customerServiceWarranty');
    return (response.data ?? []) as CustomerServiceWarrantyOption[];
  } catch (error) {
    console.error('Error fetching customer service warranties:', error);
    throw error;
  }
};
